module.exports = __webpack_public_path__ + "static/media/business-homepage-new.cfcd248c.jpg";